export default function ContactFooter() {
  return (
    <footer className="w-full bg-background-50 py-12 md:py-16 px-6 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="rounded-xl bg-foreground-900 px-8 md:px-14 py-14 md:py-18">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
            {/* Left: Section Label */}
            <div className="w-full lg:w-[25%]">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-background-50">
                Contact
              </h2>
            </div>

            {/* Middle: Labels */}
            <div className="w-full lg:w-[25%]">
              <p className="font-heading text-base font-medium text-background-200 mb-5">
                Information
              </p>
              <ul className="space-y-2.5">
                <li className="text-sm text-background-400">Address</li>
                <li className="text-sm text-background-400">City</li>
                <li className="text-sm text-background-400">Postal Code</li>
                <li className="text-sm text-background-400">Country</li>
                <li className="text-sm text-background-400">Phone</li>
                <li className="text-sm text-background-400">Email</li>
              </ul>
            </div>

            {/* Right: Actual Contact Details */}
            <div className="w-full lg:w-[50%]">
              <p className="font-heading text-base font-medium text-background-200 mb-5">
                Details
              </p>
              <div className="space-y-2.5">
                <p className="text-sm text-background-50">Gerviu g. 16</p>
                <p className="text-sm text-background-50">Zeimiai</p>
                <p className="text-sm text-background-50">55385</p>
                <p className="text-sm text-background-50">Lithuania</p>
                <p className="text-sm text-background-50">+370 66806323</p>
                <p className="text-sm text-background-50">contact@medisoftas.com</p>
              </div>
            </div>
          </div>

          {/* Decorative Line Element */}
          <div className="mt-14 pt-8 border-t border-foreground-700/40" aria-hidden="true">
            <div className="flex gap-2">
              <span className="w-12 h-px bg-accent-500/40" />
              <span className="w-6 h-px bg-accent-500/25" />
              <span className="w-16 h-px bg-primary-500/35" />
              <span className="w-4 h-px bg-accent-500/20" />
              <span className="w-10 h-px bg-primary-500/30" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}